// Shared function to build more unique process identifiers to follow the same pattern everywhere

export class ProcessIdBuilder {
  static generateId(...parts) {
    return parts.join('.');
  }
}
